// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"MediumTile_Wrapper__J1534","Container":"MediumTile_Container__JrHtN","Image":"MediumTile_Image__CXF0l","Name":"MediumTile_Name__XYiMA"};